import { IWidgetChannelServer } from '../channel';

export enum WidgetContactFormMode {
  beforeDialog = 'before_dialog',
  duringDialog = 'during_dialog',
  disabled = 'disabled'
}

export enum WidgetContactFormSubmitStatus {
  pending = 'pending',
  submitted = 'submitted'
}

export enum WidgetConsentsKeyServer {
  personalData = 'personal_data',
  mailing = 'mailing'
}

export enum WidgetContactFormFieldType {
  phone = 'phone',
  email = 'email',
  name = 'name'
}

export enum WidgetTheme {
  light = 'light',
  dark = 'dark',
  system = 'system'
}

export enum WidgetHeaderType {
  logo = 'logo',
  text = 'text'
}

export type WidgetContactFormFieldServer = {
  type: WidgetContactFormFieldType;
  required: boolean;
};

export type WidgetContactFormServer = {
  mode: WidgetContactFormMode;
  fields: WidgetContactFormFieldServer[];
};

export enum WidgetConsentsType {
  personalData = 'personalData',
  mailing = 'mailing'
}

export enum WidgetConsentSubmitStatus {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected'
}

export type WidgetConsentItemServer = {
  is_enabled: boolean;
  is_required: boolean;
  doc_url: string | null;
};

export type WidgetConsentsServer = {
  personal_data: WidgetConsentItemServer;
  mailing: WidgetConsentItemServer;
};

export type FileServer = {
  _id: string;
  url: string;
  filename: string;
};

export enum WidgetFontType {
  preset = 'preset',
  custom = 'custom'
}

export type WidgetPresetFontServer = {
  type: WidgetFontType.preset;
  name: string;
};

export type WidgetCustomFontServer = {
  type: WidgetFontType.custom;
  _id: string;
  url: string;
  filename: string;
};

export type WidgetFontServer = WidgetPresetFontServer | WidgetCustomFontServer;

export type WidgetHeaderServer = {
  type: WidgetHeaderType;
  logo_url: string | null;
  title: string | null;
  subtitle: string | null;
};

export type WidgetButtonServer = {
  icon_url: string | null;
};

export type WidgetSubmitStatusServer = {
  contact_form: WidgetContactFormSubmitStatus;
  personal_data_consent: WidgetConsentSubmitStatus;
  mailing_consent: WidgetConsentSubmitStatus;
};

export type WidgetSocialButtonServer = IWidgetChannelServer;

export type WidgetConfigServer = {
  customization: WidgetCustomizationServer;
  submit_statuses: WidgetSubmitStatusServer;
  social_buttons: WidgetSocialButtonServer[];
};

export type WidgetWelcomeMessageServer = {
  is_enabled: boolean;
  text: string | null;
};

export type WidgetCustomizationServer = {
  contact_form: WidgetContactFormServer;
  consents: WidgetConsentsServer;
  theme: WidgetTheme;
  primary_color: string;
  font: WidgetFontServer;
  background: FileServer | null;
  header: WidgetHeaderServer;
  button: WidgetButtonServer;
  bot_avatar_url: string | null;
  welcome_message?: WidgetWelcomeMessageServer;
};
